export enum CommercialBusiness {
  ONE_YEAR = 'ONE_YEAR',

  SIX_MONTH = 'SIX_MONTH',
}
